import React from "react";
import { Alert } from "react-bootstrap";
import LogHelper from "../helpers/LogHelper";


const errors = {
  400: "BAD_REQUEST",
  401: "UNAUTHORIZED",
  403: "FORBIDDEN",
  404: "NOT_FOUND",
  409: "CONFLICT",
  412: "PRECONDITION_FAILED",
  429: "TOO_MANY_REQUESTS",
  500: "SERVER_ERROR",
  502: "BAD_GATEWAY",
  9999: "ALREADY_DOWNLOADED"
};

const messages = {
  400: "APIError.BadRequest",
  401: "APIError.Unauthorized",
  403: "APIError.Forbidden",
  404: "APIError.NotFound",
  409: "APIError.Conflict",
  412: "APIError.PreconditionFailed",
  429: "APIError.TooManyRequests",
  500: "APIError.ServerError",
  502: "APIError.ServerError"
};

class APIErrorHelper {
  static getError(err, closeHandle, msgs, trans, timeMS) {
    if (timeMS) {
      setTimeout(closeHandle, timeMS);
    }
    try {
      const errorString = JSON.stringify(err, Object.getOwnPropertyNames(err));
      LogHelper.log("Request Error", errorString);
    }catch (err){}

    if (typeof err.status !== "undefined") {
      return (
        <Alert variant="danger" onClose={closeHandle} dismissible>
          {typeof msgs[errors[err.status]] !== "undefined"
            ? trans === null ? msgs[errors[err.status]] : trans(msgs[errors[err.status]])
            : trans(messages[err.status])}
        </Alert>
      );
    }
    return (
      <Alert variant="danger" onClose={closeHandle} dismissible>
        {trans(messages["500"])}
      </Alert>
    );
  }
}

export default APIErrorHelper;
